/* eslint no-console:0 */

// const componentRequireContext = require.context('landing_parts', true);
// const ReactRailsUJS = require('react_ujs');

// ReactRailsUJS.useContext(componentRequireContext);

import { mountComponents } from '../lib/react_rails_mounter';

// const ReactRailsUJS = require('react_ujs');
// const componentRequireContext = require.context('shared_app', true);

// ReactRailsUJS.useContext(componentRequireContext);

mountComponents({
  SocialProofs: require('../landing_parts/SocialProofs/SocialProofs'),
});
